/**
 * Collapsible Rows Initialization
 * This script ensures that any collapsible rows that are open by default
 * display properly from the moment the page loads.
 */

document.addEventListener('DOMContentLoaded', function() {
  // Get all collapsible rows
  const collapsibleRows = document.querySelectorAll('.savia-collapsible-row');
  
  // Auto-open first collapsible row if setting is enabled
  const productInfo = document.querySelector('product-info');
  if (productInfo && productInfo.dataset.autoOpenFirst === 'true' && collapsibleRows.length > 0) {
    collapsibleRows[0].setAttribute('open', '');
  }
  
  // Function to ensure collapsible rows display properly when open
  function ensureProperDisplay() {
    collapsibleRows.forEach(row => {
      if (row.hasAttribute('open')) {
        const wrapper = row.querySelector('.savia-collapsible-row__content-wrapper');
        const content = row.querySelector('.savia-collapsible-row__content');
        
        if (wrapper) {
          wrapper.style.height = 'auto';
          wrapper.style.overflow = 'visible';
          wrapper.style.display = 'block';
          wrapper.style.opacity = '1';
          wrapper.style.visibility = 'visible';
          wrapper.style.maxHeight = 'none';
        }
        
        if (content) {
          content.style.display = 'block';
          content.style.visibility = 'visible';
          content.style.opacity = '1';
          content.style.position = 'relative';
          content.style.zIndex = '10';
          content.style.maxHeight = 'none';
        }
      }
    });
  }
  
  // Run immediately and after a short delay
  ensureProperDisplay();
  setTimeout(ensureProperDisplay, 300);
  
  // Watch for clicks on the collapsible rows
  collapsibleRows.forEach(row => {
    const summary = row.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', function(e) {
        // Small delay to ensure the detail's open state has changed
        setTimeout(ensureProperDisplay, 10);
      });
    }
  });
  
  // Also watch for attribute changes
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        ensureProperDisplay();
      }
    });
  });
  
  collapsibleRows.forEach(row => {
    observer.observe(row, { attributes: true });
  });
  
  // Make sure icon with text blocks are visible
  const iconTextItems = document.querySelectorAll('.icon-text-item');
  if (iconTextItems.length > 0) {
    iconTextItems.forEach(item => {
      item.style.display = 'flex';
      const icon = item.querySelector('.icon-container');
      const text = item.querySelector('.icon-text');
      if (icon) icon.style.display = 'flex';
      if (text) text.style.visibility = 'visible';
    });
  }
});
